export const LOADED = "book/loaded"
export const ADDBOOK = "book/addBook"
export const UPDATE = "book/update"
export const DELETE = "book/delete"
export const ALL = "book/allFilter"
export const FEATURED = "book/featuredFilter"
export const NAMEFILTERED = "book/nameFilter"